import { formatCurrency } from "@/utils/format-currency";
import { formatLabel } from "@/utils/format-label";
import { Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import { SettlementActionsPopover } from "./settlement-actions-popover";

export const SettlementColumns = [
  {
    accessorKey: "settlementReferenceId",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Ref ID</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.settlementReferenceId ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "merchantName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Merchant</div>,
    cell: ({ row }) => (
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {row.original.merchantName ?? "N/A"}
        </div>
        <div style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 2 }}>
          {row.original.merchantId ?? "N/A"}
        </div>
      </div>
    ),
  },
  {
    accessorKey: "settlementGrossAmount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Actual Amount</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatCurrency(row.original.settlementGrossAmount) ?? "0"}
      </div>
    ),
  },
  {
    accessorKey: "totalFee",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Fee</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", color: "#991b1b" }}>
        {formatCurrency(row.original.totalFee) ?? "0"}
      </div>
    ),
  },
  {
    accessorKey: "settlementNetAmount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Settled Amount</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", fontWeight: 500 }}>
        {formatCurrency(row.original.settlementNetAmount) ?? "0"}
      </div>
    ),
  },
  {
    accessorKey: "settlementStatus",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const status = row.original.settlementStatus;

      const getStatusColor = () => {
        switch (status) {
          case "SETTLED":
            return { bg: "#ecfdf5", color: "#065f46" };
          case "FAILED":
            return { bg: "#fef2f2", color: "#991b1b" };
          case "PROCESSING":
            return { bg: "#eff6ff", color: "#1e40af" };
          case "PENDING":
          default:
            return { bg: "#fffbeb", color: "#92400e" };
        }
      };

      const { bg, color } = getStatusColor();

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color: color,
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {formatLabel(status) ?? "N/A"}
        </Box>
      );
    },
  },
  {
    accessorKey: "dateSettled",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Settlement Date</div>,
    cell: ({ row }) => {
      const date = row.original.dateSettled;

      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      const parsed = parseISO(date);

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A"}
        </div>
      );
    },
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Actions</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", cursor: "pointer" }}>
        <SettlementActionsPopover settlement={row.original} />
      </div>
    ),
  },
];